import { Fragment, memo } from 'react';
import ReactMarkDown from 'react-markdown';
import cn from 'classnames';

import styles from './footer.module.scss';
import Label from '../label/label';
import { ICustomLabel } from '../../../interfaces/custom-label.interface';
import logoImg from '../../../assets/img/logo.png';

import { appConfig } from '../../../config/app.config';
import { Animate } from '../../animation/animation';
import { useMediaQuery } from 'react-responsive';
import { SceneToken } from '../../../enums/scene-token.enum';

interface FooterProps {
  text?: string;
  domain: string;
  mode?: "default" | "onlyLabel";
  customLabel?: ICustomLabel;
  whiteLabel?: boolean;
  currentSceneToken: SceneToken
}

export const Footer = memo(({ text, domain, mode = "default", customLabel, whiteLabel, currentSceneToken }: FooterProps) => {
  const logoUrl = customLabel?.image?.url ? appConfig().assets_url + customLabel?.image?.url : logoImg;
  const minWidth768 = useMediaQuery({ minWidth: 768 });
  const finalPage = currentSceneToken == SceneToken.FINAL;

  return (<>{(currentSceneToken != SceneToken.QUESTION || minWidth768) && <Animate when={true} delay={100} duration={500} animation={'fade'}>
    <div className={cn(styles.footer, styles[mode], { [styles.finalPage]: finalPage })}>
      {(!whiteLabel || customLabel) &&
        <Label place="default" domain={domain} logo={logoUrl} text={customLabel?.text} link={customLabel?.url} />
      }

      <div className={cn(styles.information, { [styles.whiteLabel]: whiteLabel })}>
        <div className={styles.disclamer}>Имеются противопоказания, необходима консультация специалиста. Предложение не является публичной офертой</div>
        {text && <ReactMarkDown
          source={text}
          escapeHtml={false}
          renderers={{ paragraph: props => <Fragment children={props.children} /> }}
        />}
      </div>
    </div>
  </Animate>}</>);
});